/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * Element directive to represent an Image within the contents of a page.
 */
angular.module('bulbApp.contentEditorModule')

.directive('imageBlock', ['BulbAuthService','CONFIG', imageBlock]);

function imageBlock(BulbAuthService, CONFIG) {
  return {
    restrict: 'E',
    controller: 'ImageBlockController as imageBlockCtrl',
    templateUrl: 'ajs/components/contenteditor/imageblock.html',
    link: function(scope, elem, attr, ctrls) {
      scope.currentUser = BulbAuthService.currentUser;
    }
  };
}
